module.exports = __webpack_public_path__ + "img/bc5af70.png";